import { cloneDeep, get } from 'lodash';

export function transformOptionData(model: Record<string, unknown>) {
  const cloned = cloneDeep(model);
  const keys = Object.keys(model);

  // TODO: need to cleanup all formsy to return value or option with label in seperate component
  // https://coriolistechnologies.atlassian.net/browse/KOS-1899
  keys.forEach((k) => {
    const v = get(model, k);
    if (get(v, 'alias')) {
      // this is an option value, convert to alias
      cloned[k] = get(v, 'alias');
    }
  });
  return cloned;
}
